import React, { FunctionComponent, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { AppState } from "../../store";
import { Store } from "../../models/Store";
import { thunkFetchStores } from "../../store/stores/actions";
import { StoresState } from "../../store/stores/types";

interface StoreSelectProps extends Omit<SelectProps, "loading"> {
  filterOpened?: boolean;
  excludeStoreIds?: Array<string>;
  label?: string;
  onSelected?: (value: Store) => void;
  variant?: "filled" | "outlined" | "standard";
  value?: string;
  error?: boolean;
}

export const StoreSelect: FunctionComponent<StoreSelectProps> = ({
  filterOpened,
  excludeStoreIds,
  label = "Store",
  onSelected,
  onChange,
  variant = "standard",
  value,
  error = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const storesState = useSelector<AppState, StoresState>(s => s.stores);
  let { stores } = storesState;

  const [state, setState] = useState<ReadonlyArray<Store>>([]);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      let store = state.find(s => s.id === event.target.value);
      if (store) {
        onSelected(store);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  useEffect(() => {
    let filtered =
      stores &&
      stores.length > 0 &&
      stores
        .filter(
          store =>
            filterOpened === undefined ||
            (filterOpened &&
              (store.state === "Opened" || store.state === "InSetup")) ||
            (!filterOpened && store.state === "Closed")
        )
        .filter(
          store =>
            excludeStoreIds === undefined ||
            !excludeStoreIds.some(x => x === store.id)
        );

    if (filtered) {
      setState(filtered);
    }
  }, [stores]);

  useEffect(() => {
    // load if not loaded
    if (!stores || !stores.length) {
      dispatch(thunkFetchStores());
    }
  }, []);

  return (
    <FormControl variant={variant} className={props.className} error={error}>
      <InputLabel
        id="store-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        labelId="store-select-label"
        id="store-select"
        autoWidth={true}
      >
        {state &&
          state.length > 0 &&
          state.map(store => (
            <MenuItem key={store.id} value={store.id}>
              {filterOpened === undefined ? (
                <b
                  style={{
                    fontSize: "2rem",
                    marginRight: "1rem",
                    color:
                      store.state === "Opened"
                        ? "green"
                        : store.state === "InSetup"
                        ? "orange"
                        : "red"
                  }}
                >
                  ·
                </b>
              ) : null}{" "}
              {store.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
